export interface EpicSettingsSlack {
    channels?: Array<string>;
}

export function EpicSettingsSlackFromJSON(json: any): EpicSettingsSlack {
    return {
        channels: (json["channels"] === undefined || json["channels"] == null) ? undefined :json['channels'] as Array<string>,
    }
}
